var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseItem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2608_33476)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.00004 7.16671L1.91671 11.25C1.76393 11.4028 1.56949 11.4792 1.33337 11.4792C1.09726 11.4792 0.902818 11.4028 0.75004 11.25C0.597263 11.0973 0.520874 10.9028 0.520874 10.6667C0.520874 10.4306 0.597263 10.2362 0.75004 10.0834L4.83337 6.00004L0.75004 1.91671C0.597263 1.76393 0.520874 1.56949 0.520874 1.33337C0.520874 1.09726 0.597263 0.902818 0.75004 0.75004C0.902818 0.597263 1.09726 0.520874 1.33337 0.520874C1.56949 0.520874 1.76393 0.597263 1.91671 0.75004L6.00004 4.83337L10.0834 0.75004C10.2362 0.597263 10.4306 0.520874 10.6667 0.520874C10.9028 0.520874 11.0973 0.597263 11.25 0.75004C11.4028 0.902818 11.4792 1.09726 11.4792 1.33337C11.4792 1.56949 11.4028 1.76393 11.25 1.91671L7.16671 6.00004L11.25 10.0834C11.4028 10.2362 11.4792 10.4306 11.4792 10.6667C11.4792 10.9028 11.4028 11.0973 11.25 11.25C11.0973 11.4028 10.9028 11.4792 10.6667 11.4792C10.4306 11.4792 10.2362 11.4028 10.0834 11.25L6.00004 7.16671Z",
    fill: "#2B363B",
    fillOpacity: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2608_33476"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseItem);
export default __webpack_public_path__ + "static/media/close-item.17f09cae8aff2344ffaed9adf7724b7c.svg";
export { ForwardRef as ReactComponent };